import { Component, OnInit } from '@angular/core';
import {Observable} from "rxjs";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {map, shareReplay} from "rxjs/operators";
import {AppComponent} from "../../../app.component";

@Component({
  selector: 'app-mobile-metrics',
  templateUrl: './mobile-metrics.component.html'
})
export class MobileMetricsComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  step = 0;

  constructor(public application: AppComponent,
              private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  saveAndClose() {
    if(this.application.state === 'messenger') {
      window['closeWebView']();
    } if(this.application.state === 'squash') {
      window['location']['href'] = 'viber://pa?chatURI=squashfitcenterlviv&context=webapp';
    }
  }

}
